// client/src/components/admin/marketer/PointRefundList.js
import React, { useState, useEffect } from 'react';
import '../../../styles/admin/AdminTable.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function PointRefundList({ 
  onSelect, 
  selectedId, 
  interactive = false, 
  refreshToken = 0,
  search = ''
}) {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const pageSize = 10;

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshToken, page, search]);

  const fetchList = async () => {
    setLoading(true);
    setError('');
    try {
      const url = `${API_URL}/api/admin/advertiser/refund/list?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search)}`;
      const res = await fetch(url, { credentials: 'include' });
      const data = await res.json();
      
      if (data.ok) {
        setItems(data.items || []);
        setTotalPages(data.totalPages || 0);
      } else {
        setError(data.message || '불러오기 실패');
      }
    } catch (err) {
      console.error('fetchList error:', err);
      setError('불러오기 실패');
    }
    setLoading(false);
  };

  const fmt = (ts) => ts ? new Date(ts).toLocaleString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }) : '';

  return (
    <div className="admin-list">
      <div className="admin-list__header">환불 요청 목록</div>
      
      <div className="admin-list__body">
        {error && <div className="admin-list__error">{error}</div>}
        {loading && <div className="admin-list__loading">불러오는 중...</div>}
        {!loading && items.length === 0 && !error && (
          <div className="admin-list__empty">환불 요청이 없습니다.</div>
        )}
        
        {!loading && items.length > 0 && (
          <div>
            {items.map((item) => (
              <div
                key={item._id}
                onClick={interactive && onSelect ? () => onSelect(item) : undefined}
                className={`admin-list__item ${
                  selectedId === item._id ? 'admin-list__item--selected' : ''
                }`}
                style={{ cursor: interactive ? 'pointer' : 'default' }}
              >
                <div className="admin-list__item-row">
                  <div className="admin-list__item-main">
                    {item.marketerUserId} <span className="admin-list__item-sub">({item.marketerUserName})</span>
                  </div>
                  <div className="admin-list__item-meta">{fmt(item.requestedAt)}</div>
                </div>
                <div className="admin-list__item-row" style={{ marginTop: '4px' }}>
                  <div className="admin-list__item-sub" style={{ fontSize: '13px', color: 'var(--admin-text-body)' }}>
                    신청: {item.requestedPoints.toLocaleString()}pt → {item.refundAmount.toLocaleString()}원
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 페이지네이션 */}
      {totalPages > 1 && (
        <div className="admin-list__pagination">
          <div className="admin-list__pagination-info">
            Page {page} of {totalPages}
          </div>
          <div className="admin-list__pagination-buttons">
            <button
              className="admin-list__pagination-button"
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              ◀
            </button>
            <button
              className="admin-list__pagination-button"
              onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
            >
              ▶
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PointRefundList;
